export const GNOSIS_PAY_ENDPOINT = 'https://api.gnosispay.com/api/v1';

export const PAY_NONCE_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/auth/nonce`;
export const PAY_CHALLENGE_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/auth/challenge`;
export const PAY_USER_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/user`;
export const PAY_TRANSACTIONS_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/transactions`;
export const PAY_CARDS_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/cards`;

export const PAY_ACCOUNT_BALANCE_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/account-balances`;

export const PAY_SOURCE_OF_FUNDS_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/source-of-funds`;

export const PAY_REWARDS_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/rewards`;
export const PAY_TERMS_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/user/terms`;
export const PAY_SAFE_CONFIG_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/safe-config`;

export const PAY_DEPLOY_SAFE_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/safe/deploy`;
export const PAY_LIST_DELAY_TRANSACTIONS_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/delay-relay`;

// spending limit
export const PAY_SPENDING_LIMIT_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/accounts/onchain-daily-limit`;
export const PAY_GET_SPENDING_LIMIT_TRANSACTION_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/accounts/onchain-daily-limit/transaction-data`;
export const PAY_SET_SPENDING_LIMIT_TRANSACTION_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/accounts/onchain-daily-limit`;

// withdraw
export const PAY_GET_WITHDRAW_TRANSACTION_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/accounts/withdraw/transaction-data`;
export const PAY_WITHDRAW_TRANSACTION_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/accounts/withdraw`;

// owners
export const PAY_ADD_OWNER_TRANSACTION_DATA_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/owners/add/transaction-data`;
export const PAY_REMOVE_OWNER_TRANSACTION_DATA_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/owners/remove/transaction-data`;
export const PAY_OWNER_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/owners`;

// iban
export const PAY_CHECK_IBAN_AVAILABILITY_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/ibans/available`;
export const PAY_GET_IBAN_DETAILS_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/ibans/details`;
export const PAY_GET_IBAN_INTEGRATION_ENDPOINT = `${GNOSIS_PAY_ENDPOINT}/integrations/monerium`;
